<p>create-notification-details works!</p>
